export default {
    computed: {
        isAdmin() {
            return this.checkRole('isAdmin')
        },
        isManager() {
            return this.checkRole('isManager')
        },
        isEmployee() {
            return this.checkRole('isEmployee')
        },
        isAdminOrManager() {
            return this.isAdmin || this.isManager
        },
    },
    methods: {
        checkRole(role) {
            if (! this.user) return false
            return this.user[role] || false
        },
    },
}
